import { Badge, Flex, Grid, SelectField } from "@aws-amplify/ui-react";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";

import { maintenanceRoutinesByCompanyID } from "graphql/queries";

const SelectMaintenanceRoutine = ({
  initialValues,
  onChangeMaintenanceRoutines,
  companyID,
}) => {
  const [maintenanceRoutineSelectedList, setMaintenanceRoutineSelectedList] =
    useState([]);
  const [maintenanceRoutines, setMaintenanceRoutines] = useState([]);

  const onDelete = (index) => {
    setMaintenanceRoutineSelectedList((prevSt) => {
      const listUpdated = [...prevSt];
      listUpdated.splice(index, 1);
      if (onChangeMaintenanceRoutines) onChangeMaintenanceRoutines(listUpdated);
      return listUpdated;
    });
  };

  const onSelect = (e) => {
    const { value } = e.target;

    setMaintenanceRoutineSelectedList((prevSt) => {
      const listUpdated = [...prevSt, value];
      if (onChangeMaintenanceRoutines) onChangeMaintenanceRoutines(listUpdated);
      return listUpdated;
    });
  };

  async function fetchMaintenanceRoutines() {
    try {
      if (!companyID) return;
      const maintenanceRoutinesData = await API.graphql(
        graphqlOperation(maintenanceRoutinesByCompanyID, {
          companyID,
          filter: {
            deletedAt: { attributeExists: false },
          },
        })
      );
      const maintenanceRoutinesItems =
        maintenanceRoutinesData.data.maintenanceRoutinesByCompanyID.items;
      setMaintenanceRoutines(maintenanceRoutinesItems);
    } catch (err) {
      toast.error(strings.responses.errorFetchMaintenanceRoutines);
    }
  }

  useEffect(() => {
    setMaintenanceRoutineSelectedList(initialValues ?? []);
  }, [initialValues]);

  useEffect(() => {
    fetchMaintenanceRoutines();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid rowGap="15px">
      <Grid templateColumns={{ base: "1fr" }} rowGap="15px" columnGap="15px">
        <SelectField
          name="maintenanceRoutine"
          label={strings.fields.addMaintenanceRoutine.label}
          onChange={onSelect}
        >
          <option value="">{strings.selectOption}</option>
          {maintenanceRoutines
            ?.filter(
              (maintenanceRoutine) =>
                !maintenanceRoutineSelectedList?.some(
                  (maintenanceRoutineSel) =>
                    maintenanceRoutineSel === maintenanceRoutine.id
                )
            )
            .map((maintenanceRoutine) => (
              <option key={maintenanceRoutine.id} value={maintenanceRoutine.id}>
                {maintenanceRoutine.name}
              </option>
            ))}
        </SelectField>
      </Grid>
      <Flex rowGap="10px" columnGap="10px" wrap="wrap">
        {maintenanceRoutineSelectedList?.map((maintenanceRoutineSel, index) => (
          <Badge key={index}>
            {
              maintenanceRoutines?.find(
                (maintenanceRoutine) =>
                  maintenanceRoutine.id === maintenanceRoutineSel
              )?.name
            }
            &nbsp;
            <CloseIcon
              style={{ cursor: "pointer" }}
              fontSize="inherit"
              onClick={() => onDelete(index)}
            />
          </Badge>
        ))}
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    selectOption: "Seleccione una opción",
    fields: {
      addMaintenanceRoutine: {
        label: "Agregar Rutina de Mantenimiento",
      },
    },
    responses: {
      errorFetchMaintenanceRoutines: "Error al consultar rutinas de mantenimiento",
    },
  },
});

export default SelectMaintenanceRoutine;
